<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol sm="12" md="6" xl="6">
                  
                  <BaseInput
                    :options="codeInput.options"
                    :data="codeInput.data"
                  />
                </CCol>

                <CCol sm="12" md="6" xl="6">
                    <BaseInput
                        :options="nameInput.options"
                        :data="nameInput.data"
                    />
                </CCol>

                <CCol sm="12" md="6" xl="6">
                  <BaseSelect
                    :options="statusSelect.options"
                    :data="statusSelect.data"
                    ref="status"
                    >
                  </BaseSelect>
                </CCol>
                

                

                <CCol sm="12" md="6" xl="6">
                    <BaseSelect
                        :options="isActiveSelect.options"
                        :data="isActiveSelect.data"
                        ref="isActive"
                    >
                    </BaseSelect>
                </CCol>

                <CCol sm="12" md="6" xl="6">
                  <!-- <BaseInput
                    :options="priceInput.options"
                    :data="priceInput.data"
                  /> -->
                  <div class="form-group form-input-wrapper">
                    <label class="col-form-label">Giá sản phẩm *</label> <br/>
                    <template>
                      <currency-input
                        class="form-control"
                        v-model="priceInput.data.model"
                        currency="VND"
                        locale="vi"
                      />
                    </template>
                    <div
                        class="valid-error"
                        v-show="!priceInput.data.validator.isValid"
                      >
                        {{ priceInput.data.validator.errorMessage }}
                      </div>
                  </div>
                </CCol>

                
                    <!-- <BaseSelect
                        :options="categorySelect.options"
                        :data="categorySelect.data"
                        ref="categorySelect">
                    </BaseSelect> -->
                    <!-- <div class="form-group form-input-wrapper">
                      <label class="col-form-label">Danh mục *</label>
                      <Multiselect  v-model="categorySelect.data.model" :options="categorySelect.data.items" :close-on-select="false" 
                        :clear-on-select="false" track-by="code" selectLabel="" deselectLabel=""
                        :multiple="true" label="name" placeholder="Chọn danh mục" ref="categorySelect">
                        <span slot="noResult">Danh sách trống</span>
                      </Multiselect>
                      <div
                        class="valid-error"
                        v-show="!categorySelect.data.validator.isValid"
                      >
                        {{ categorySelect.data.validator.errorMessage }}
                      </div>
                    </div> -->
              </CRow>

              <CRow>
                <CCol sm="12" md="12" xl="12">
                  <div class="form-group form-input-wrapper">
                      <label class="col-form-label">Danh mục *</label>
                      <Multiselect  v-model="categorySelect.data.model" :options="categorySelect.data.items" :close-on-select="false" 
                        :clear-on-select="false" track-by="code" selectLabel="" deselectLabel=""
                        :multiple="true" label="text" placeholder="Chọn danh mục" ref="categorySelect">
                        <span slot="noResult">Danh sách trống</span>
                      </Multiselect>
                      <div
                        class="valid-error"
                        v-show="!categorySelect.data.validator.isValid"
                      >
                        {{ categorySelect.data.validator.errorMessage }}
                      </div>
                    </div>
                </CCol>
              </CRow>

              <CRow>
                <CCol sm="12" md="12" xl="12">
                  <div class="form-group form-input-wrapper">
                    <label class="col-form-label">Mô tả sản phẩm *</label>
                      <CTextarea
                          @blur="descriptionInput.data.validator.valid()"
                          v-model="descriptionInput.data.model"
                      />
                      <div
                        class="valid-error"
                        v-show="!descriptionInput.data.validator.isValid"
                      >
                        {{ descriptionInput.data.validator.errorMessage }}
                      </div>
                    </div>
                </CCol>
              </CRow>

              <CRow>
                <CCol sm="12" md="12" xl="12">
                  <div class="form-group form-input-wrapper">
                    <label class="col-form-label">Mô tả chi tiết sản phẩm *</label>
                      <ckeditor :editor="editor" v-model="contentInput.data.model" :config="editorConfig"></ckeditor>
                      <div
                        class="valid-error"
                        v-show="!contentInput.data.validator.isValid"
                      >
                        {{ contentInput.data.validator.errorMessage }}
                      </div>
                  </div>
                </CCol>
              </CRow>

              <CRow>
                <CCol sm="12" md="12" xl="12">
                    <div class="form-group form-input-wrapper">
                      <!-- <label class="col-form-label">Chính sách</label><br /> -->
                      
                      <CRow>
                        <!-- <div class="" style="display: inline-flex;"> -->
                          <CCol v-for="each in policiesInput.data.items"
                            :key="each.id" sm="12" md="6" xl="6">
                            <label>{{each.name}}</label>
                            <CRow style="padding-left: 5%" v-for="eachDetail in each.lstPolicyDetail" :key="eachDetail.id" class="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                class="custom-control-input"
                                v-model="eachDetail.checked"
                                :value="eachDetail.id"
                                :id="eachDetail.id"
                              />
                              <label
                                class="custom-control-label mr-3"
                                :for="eachDetail.id"
                                >{{ eachDetail.name }}</label
                              >
                            </CRow>
                          </CCol>
                            
                          <!-- </div> -->
                      </CRow>    
                      
                    </div>
                  </CCol>
                </CRow>

              <CRow>
                <CCol sm="12" md="12" xl="12">
                  <div class="form-group form-input-wrapper">

                    <label class="col-form-label">Danh sách ảnh sản phẩm</label>
                    <br/>

                    <input @change="changeFiles($event)" id="fileUpload" type="file" ref="files" multiple="multiple" hidden>
                    <CButton
                      color="primary"
                      style="float:right"
                      @click="chooseFiles()"
                      class="btn-action-primary mr-2"
                    >
                      <i class="fa fa-upload"></i> Tải ảnh lên
                    </CButton>


                    <div v-if="lstImg.length > 0">
                      <CDataTable
                        :items="lstImg"
                        :fields="fields"
                        :sorterValue="{ column: null, asc: 'true' }"
                        hover
                      >
                        <template #fileOrder="{item}">
                          <td style="text-align:center;top: 50%">{{item.fileOrder}}</td>
                        </template>
                        <template #imgPath="{item}">
                          <td style="text-align:center">
                            <img :src="item.imgPath" alt="" style="width: 150px">
                          </td>
                        </template>
                        <template #action="{item}">
                          <td class="action-btn-group">
                              <div class="action-btn-wrapper">
                                <CButton color="info"
                                        variant="outline"
                                        v-c-tooltip.hover="'Lên vị trí'"
                                        square
                                        size="sm"
                                        @click="upOrder(item)">
                                  <CIcon name="cil-arrow-top"/>
                                </CButton>
                                <CButton
                                  color="info"
                                  variant="outline"
                                  class="ml-1"
                                  square
                                  size="sm"
                                  v-c-tooltip.hover="'Xuống vị trí'"
                                  @click="downOrder(item)">
                                  <CIcon name="cil-arrow-bottom"/>
                                </CButton>
                                <CButton
                                  color="danger"
                                  variant="outline"
                                  class="ml-1"
                                  square
                                  size="sm"
                                  v-c-tooltip.hover="'Xóa'"
                                  @click="deleteImg(item)">
                                  <CIcon name="cil-trash"/>
                                </CButton>
                              </div>
                          </td>
                        </template>
                      </CDataTable>
                    </div>
                  </div>
                  
                </CCol>
              </CRow>



              <div slot="footer" class="mt-4">
                <CButton
                  color="primary"
                  class="btn-action-primary mr-2"
                  @click="submitData"
                >
                  <i class="fa fa-plus"></i> Thêm mới
                </CButton>
                <CButton
                  color="secondary"
                  class="btn-action-primary"
                  @click="$router.push('/products-management/managed-product')"
                ><i class="fa fa-reply"></i> Hủy bỏ
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import BaseTable from "../base/BaseDataTable";
import Multiselect from 'vue-multiselect';

export default {
  name: "ProductAdd",
  components: {BaseSelect, BaseInput, BaseLoading, ClassicEditor, BaseTable, Multiselect},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      editor: ClassicEditor,
      editorConfig: {
        ckfinder: {
          uploadUrl: process.env.API_ENDPOINT + '/fileAttachment/uploadFile',
          options: {
              resourceType: 'Images'
          }

        }
      },
      files:[],
      lstImg: [],
      fields: [
        {key: 'fileOrder', label: 'STT', _style:'width: 10%; text-align:center'},
        {key: 'imgPath', label: 'Ảnh', _style:'width: 70%; text-align:center'},
        {key: 'action', label: 'Thao tác', _style:'width: 20%;'},
      ],
      // productImage: {
      //   name: 'Chọn ảnh',
      //   isLoading: false,
      //   background: '',
      //   isLoadSuccess: false,
      //   isValid: true,
      //   errorMessage: '',
      //   data: {
      //     model: '',
      //     name: 'path',
      //   }
      // },
      codeInput: {
        options: {
          label: "Mã sản phẩm *",
          placeholder: "Mã sản phẩm",
          type: "text",
          maxlength: 100
        },
        data: {
          name: "code",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.codeInput.data.model;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Mã sản phẩm không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      nameInput: {
        options: {
          label: "Tên sản phẩm *",
          placeholder: "Tên sản phẩm",
          type: "text",
          maxlength: 200
        },
        data: {
          name: "name",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.nameInput.data.model;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Tên sản phẩm không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      isActiveSelect: {
        options: {
          filter: false,
          label: 'Trạng thái',
        },
        data: {
          name: "active",
          items: [
            {key: "true", value: "Hoạt động"},
            {key: "false", value: "Không hoạt động"},
          ],
          model: "true"
        }
      },
      statusSelect: {
        options: {
          filter: false,
          label: 'Trạng thái sản phẩm',
        },
        data: {
          name: "status",
          items: [
            {key: "true", value: "Còn hàng"},
            {key: "false", value: "Hết hàng"},
          ],
          model: "true"
        }
      },
      priceInput: {
        options: {
          label: "Giá sản phẩm *",
          placehder: "Giá sản phẩm",
          type: "text",
        },
        data: {
          name: "price",
          model: 0,
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.priceInput.data.model;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Giá sản phẩm không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      categorySelect: {
        // options: {
        //   'keyField': 'id',
        //   'valueField': 'code',
        //   label: "Danh mục *",
        // },
        data: {
          model: [],
          name: 'lstCategory',
          items: [],
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.categorySelect.data.model;
              if (value == null || value.length == 0) {
                this.isValid = false;
                this.errorMessage = "Danh mục sản phẩm không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      descriptionInput : {
        data: {
          name: "description",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.descriptionInput.data.model;
              if (value === undefined || value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Mô tả sản phẩm không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      contentInput : {
        data: {
          name: "content",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.contentInput.data.model;
              if (value === undefined || value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Mô tả chi tiết sản phẩm không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      policiesInput: {
        data: {
          name: "policies",
          model: [],
          items: []
        }
      }
    };
  },
  methods: {
    // uploadImage: function (e) {
    //   let that = this;
    //   let reader = new FileReader();
    //   let objectResult = {};
    //   let dataFile = e.target.files[0];
    //   reader.readAsDataURL(dataFile);
    //   that.productImage.isLoading = true;
    //   that.productImage.name = null;
    //   reader.onload = function () {
    //     setTimeout(function () {
    //       objectResult.fileName = dataFile.name;
    //       let readerResult = reader.result;
    //       objectResult.content = readerResult.split(',')[1];
    //       that.productImage.data.model = objectResult;
    //       that.productImage.background = readerResult;
    //       that.productImage.isLoading = false;
    //       that.productImage.isLoadSuccess = true;
    //       that.productImage.name = dataFile.name;
    //       that.validproductImage(true);
    //     }, 500);
    //   };
    //   reader.onerror = function (error) {
    //     console.log('Error: ', error);
    //   };
    // },
    // validproductImage: function (isAsync) {
    //   let that = this;
    //   // eslint-disable-next-line no-undef
    //   let file = $('#imgUpload').get(0).files && $('#imgUpload').get(0).files.length != 0;

    //   function excute() {
    //     if (file) {
    //       let type = $('#imgUpload').get(0).files[0].type;
    //       if (type != 'image/jpg' && type != 'image/jpeg' && type != 'image/png') {
    //         that.productImage.isValid = false;
    //         that.productImage.errorMessage = 'Sai định dạng file';
    //       } else {
    //         that.productImage.isValid = true;
    //         that.productImage.errorMessage = '';
    //       }
    //     } else {
    //       that.productImage.isValid = false;
    //       that.productImage.errorMessage = 'Chọn ảnh sản phẩm';
    //     }
    //   }

    //   if (isAsync) {
    //     setTimeout(function () {
    //       excute();
    //     }, 50);
    //   } else {
    //     excute();
    //   }
    // },
    submitData: function () {
      let that = this;
      // console.log(that.policiesInput.data.items);
      // this.validproductImage();
      let isValid = true;
      // isValid &= that.productImage.isValid;
      // console.log(that.categorySelect.data.model);
      isValid &= that.codeInput.data.validator.valid();
      isValid &= that.nameInput.data.validator.valid();
      isValid &= that.categorySelect.data.validator.valid();
      isValid &= that.priceInput.data.validator.valid();
      isValid &= that.descriptionInput.data.validator.valid();
      isValid &= that.contentInput.data.validator.valid();

      if (!isValid) {
        return;
      } else {
        let dataRequest = {};
        // dataRequest.path = that.productImage.data.model;
        dataRequest.code = that.codeInput.data.model;
        dataRequest.name = that.nameInput.data.model;
        dataRequest.active = that.isActiveSelect.data.model;
        dataRequest.lstCategory = that.categorySelect.data.model;
        dataRequest.price = that.priceInput.data.model;
        dataRequest.description = that.descriptionInput.data.model;
        dataRequest.content = that.contentInput.data.model;
        dataRequest.status = that.statusSelect.data.model;
        dataRequest.lstImgAdd = that.lstImg;
        dataRequest.lstPolicy = that.policiesInput.data.items;
        this.$helper.loadDataSource({
          loading: that.loading,
          url: "/product/createProduct",
          dataSubmit: function () {
            return dataRequest;
          },
          successCallback: function (response) {
            if (!that.$helper.validResponse(that.$router, response.data)) {
              that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
              that.$helper.setupErrorModel(response.data.data, that.$data);
            } else {
              that.showSuccessMsg({message: "Thêm mới sản phẩm thành công"});
              // that.$router.go(-1);
              that.$router.push('/products-management/update/' +response.data.data.id)
            }
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          }
        });
      }
    },
    loadDataCategories: function () {
      var that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/category/listCategoryActive",
        successCallback: function (response) {
          that.categorySelect.data.items = response.data.data;
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    loadDataPolicy: function () {
      var that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/policy/loadDataForProduct",
        dataSubmit: function () {
          return {}
        },
        successCallback: function (response) {
          that.policiesInput.data.items = response.data.data.data;
          // console.log(that.policiesInput.data.items);
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    chooseFiles: function(){
      document.getElementById("fileUpload").click();
    },
    changeFiles: function(e){
      let that = this;
      that.files = e.target.files;
      let stt = that.lstImg.length;
      for (let i = 0; i < that.files.length; i++) {
        let reader = new FileReader();
        let objectResult = {};
        let dataFile = this.files[i];
        reader.readAsDataURL(dataFile);
        reader.onload = function () {
          setTimeout(function () {
            stt = stt + 1;
            objectResult.fileOrder = stt;
            objectResult.fileName = dataFile.name;
            let readerResult = reader.result;
            // objectResult.content = readerResult.split(',')[1];
            objectResult.imgPath = readerResult;
            objectResult.pathBase64 = {
              content: readerResult.split(',')[1],
              fileName: dataFile.name
            };
            that.lstImg.push(objectResult);
          }, 500);
        };
        reader.onerror = function (error) {
          console.log('Error: ', error);
        };
      }
      // console.log(that.lstImg);
      // that.$refs.tableImg.items = that.lstImg;
    },
    upOrder: function(item){
      let that = this;
      let lstImgChange = [];
      let oldOder = item.fileOrder;
      let indexBeforeItem = -1;
      lstImgChange = lstImgChange.concat(that.lstImg);
      for (let i = 0; i < lstImgChange.length; i++) {
        if(lstImgChange[i].fileOrder < oldOder){
          indexBeforeItem = i;
        }

        if(oldOder == lstImgChange[i].fileOrder && indexBeforeItem != -1){
          lstImgChange[i].fileOrder = lstImgChange[indexBeforeItem].fileOrder;
          lstImgChange[indexBeforeItem].fileOrder = oldOder;

          break;

        }

      }
      that.lstImg = lstImgChange.sort(function(a,b){return a.fileOrder - b.fileOrder});
    },
    downOrder: function(item){
      let that = this;
      let lstImgChange = [];
      let oldOder = item.fileOrder;
      let indexItem = -1;
      lstImgChange = lstImgChange.concat(that.lstImg);
      for (let i = 0; i < lstImgChange.length; i++) {

        if(oldOder == lstImgChange[i].fileOrder){
          indexItem = i;
        }

        if(lstImgChange[i].fileOrder > oldOder){
          lstImgChange[indexItem].fileOrder = lstImgChange[i].fileOrder;
          lstImgChange[i].fileOrder = oldOder;
          break;

        }
      }
      that.lstImg = lstImgChange.sort(function(a,b){return a.fileOrder - b.fileOrder});
    },
    deleteImg: function(item){
      let that = this;
      let lstImgChange = [];
      let oldOder = item.fileOrder;
      for (let i = 0; i < that.lstImg.length; i++) {

        if(that.lstImg[i].fileOrder < oldOder){
          lstImgChange.push(that.lstImg[i]);
        }

        if(that.lstImg[i].fileOrder > oldOder){
          that.lstImg[i].fileOrder = that.lstImg[i].fileOrder - 1;
          lstImgChange.push(that.lstImg[i]);
        }
      }
      that.lstImg = lstImgChange.sort(function(a,b){return a.fileOrder - b.fileOrder});
    }
  },
  computed: {
    // uploadImgInputClass: function () {
    //   return {
    //     valid: this.productImage.isValid,
    //     'un-valid': !this.productImage.isValid
    //   }
    // },
  },
  created() {
  },
  mounted() {
      this.loadDataCategories();
      this.loadDataPolicy();
  },
  watch: {
    "descriptionInput.data.model": function() {
      this.descriptionInput.data.validator.valid();
    },

    // "priceInput.data.model": function() {
    //   this.priceInput.data.model = this.$helper.formatPrice(this.priceInput.data.model);
    // }
    

  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>